module.exports = __webpack_public_path__ + "img/Brand_Banner2.eb563497.png";